module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "clearfix"
  }, [_c('div', {
    staticClass: "main-content clearfix"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "row p-b-sm table-filter"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3 col-xs-6 "
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._v("\n              类型:\n              "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filter.post_category),
      expression: "filter.post_category"
    }],
    attrs: {
      "type": "checkbox",
      "name": "post_category",
      "value": "2",
      "id": "post_category-company"
    },
    domProps: {
      "checked": Array.isArray(_vm.filter.post_category) ? _vm._i(_vm.filter.post_category, "2") > -1 : (_vm.filter.post_category)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.filter.post_category,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "2",
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.filter.post_category = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.filter.post_category = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.filter.post_category = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "post_category-company"
    }
  }, [_vm._v("企业")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filter.post_category),
      expression: "filter.post_category"
    }],
    attrs: {
      "type": "checkbox",
      "name": "post_category",
      "value": "1",
      "id": "post_category-system"
    },
    domProps: {
      "checked": Array.isArray(_vm.filter.post_category) ? _vm._i(_vm.filter.post_category, "1") > -1 : (_vm.filter.post_category)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.filter.post_category,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "1",
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.filter.post_category = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.filter.post_category = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.filter.post_category = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "post_category-system"
    }
  }, [_vm._v("系统")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3 col-xs-6 "
  }, [_c('div', {
    staticClass: "row"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filter.isMy),
      expression: "filter.isMy"
    }],
    attrs: {
      "type": "checkbox",
      "id": "is_my",
      "true-value": 1,
      "false-value": 0
    },
    domProps: {
      "checked": Array.isArray(_vm.filter.isMy) ? _vm._i(_vm.filter.isMy, null) > -1 : _vm._q(_vm.filter.isMy, 1)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.filter.isMy,
          $$el = $event.target,
          $$c = $$el.checked ? (1) : (0);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.filter.isMy = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.filter.isMy = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.filter.isMy = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "is_my"
    }
  }, [_vm._v("只看我的")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-4"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6 col-xs-12"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.filter.search),
      expression: "filter.search",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "input input-sm",
    attrs: {
      "type": "text",
      "placeholder": "输入岗位名称进行搜索",
      "required": "required",
      "autocomplete": "off"
    },
    domProps: {
      "value": (_vm.filter.search)
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        _vm.reload()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.filter.search = $event.target.value.trim()
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 col-xs-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-6 n-p-l"
  }, [_c('button', {
    staticClass: "btn btn-sm btn-primary col-xs-12",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.reload()
      }
    }
  }, [_vm._v("搜 索")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 n-p-l"
  }, [_c('router-link', {
    staticClass: "btn btn-sm btn-primary col-xs-12 text-center",
    attrs: {
      "to": "/company/posts/add",
      "tag": "a"
    }
  }, [_vm._v("新 增")])], 1)])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('table', {
    staticClass: "table table-border"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("序号")]), _vm._v(" "), _c('th', [_vm._v("岗位名称")]), _vm._v(" "), _c('th', [_vm._v("能力群")]), _vm._v(" "), _c('th', [_vm._v("指标")]), _vm._v(" "), _c('th', [_vm._v("题量")]), _vm._v(" "), _c('th', [_vm._v("测评次数")]), _vm._v(" "), _c('th', [_vm._v("类型")]), _vm._v(" "), (_vm.filter.isMy === 0) ? _c('th', [_vm._v("创建人")]) : _vm._e(), _vm._v(" "), _c('th', [_vm._v("操作")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.posts), function(post, ind) {
    return _c('tr', {
      key: post._id
    }, [_c('td', [_vm._v(_vm._s(_vm.filter.start + ind + 1))]), _vm._v(" "), _c('td', [_c('span', {
      staticClass: "left"
    }, [_vm._v(_vm._s(post.name))]), _vm._v(" "), (post.alias) ? _c('div', {
      staticClass: "left tooltips"
    }, [_c('i', {
      staticClass: "fa fa-info-circle"
    }), _vm._v(" "), _c('div', {
      staticClass: "text"
    }, [_vm._v("\n                        别名："), _c('br'), _vm._v(" " + _vm._s(post.alias) + "\n                      ")])]) : _vm._e()]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.abilities.length))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.indicators.length))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.questions_num))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.evaluate_num))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.post_category === 1 ? '系统' : '企业'))]), _vm._v(" "), (_vm.filter.isMy === 0) ? _c('td', [_vm._v(_vm._s(post.post_category === 1 ? '系统' : (post.post_owner ? (post.post_owner.realname) : '企业')))]) : _vm._e(), _vm._v(" "), _c('td', [_c('router-link', {
      staticClass: "btn btn-primary btn-xs",
      attrs: {
        "to": {
          name: '/company/posts/show',
          params: {
            '_id': post._id
          }
        }
      }
    }, [_vm._v("查看")]), _vm._v(" "), (post.post_category === 2 && (_vm.user.category === 2 || ((_vm.user.role === 2 || _vm.user.role === 3) && post.post_owner && post.post_owner._id === _vm.user._id))) ? _c('router-link', {
      staticClass: "btn btn-warning btn-xs",
      attrs: {
        "to": {
          name: '/company/posts/edit',
          params: {
            '_id': post._id
          }
        }
      }
    }, [_vm._v("编辑")]) : _vm._e(), _vm._v(" "), (post.post_category === 2 && (_vm.user.category === 2 || ((_vm.user.role === 2 || _vm.user.role === 3) && post.post_owner && post.post_owner._id === _vm.user._id))) ? _c('span', {
      staticClass: "btn btn-danger btn-xs",
      on: {
        "click": function($event) {
          _vm.del(post, ind)
        }
      }
    }, [_vm._v("删除")]) : _vm._e()], 1)])
  }))])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('pagination', {
    attrs: {
      "current": _vm.filter.current,
      "length": _vm.filter.length,
      "total": _vm.filter.total,
      "page-click": _vm.go
    }
  })], 1)])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-2 col-xs-12 "
  }, [_c('h4', {
    staticClass: "table-name"
  }, [_vm._v("岗位管理")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-662d752e","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/company/post/list.vue
// module id = 487
// module chunks = 1